// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"145d82e3","186":"5bfa43f9","558":"4d6db5cc","753":"5bfa43f9","838":"5bfa43f9","842":"1f042067"}[chunkId] + ".chunk.css";
};